import WFConditions from "./WFConditions";

export default WFConditions;



// WEBPACK FOOTER //
// ./src/components/WorkFlow/WFConditions/index.js